/* Theme-local campaign display. No network calls and no product/order writes. */
(function (root) {
  'use strict';
  function countdown(endSeconds, nowMs, labels) {
    labels = labels || {};
    var end = Number(endSeconds);
    if (!Number.isFinite(end) || end <= 0) return { text: '', expired: false, valid: false };
    var remaining = end * 1000 - nowMs;
    if (remaining <= 0) return { text: labels.expiredText || '募集終了', expired: true, valid: true };
    var seconds = Math.floor(remaining / 1000);
    var parts = [];
    var units = [['Year', 31536000, '年'], ['Month', 2592000, 'ヶ月'], ['Day', 86400, '日']];
    units.forEach(function (unit) {
      var count = Math.floor(seconds / unit[1]);
      seconds %= unit[1];
      if (count) parts.push(count + ' ' + (labels[(count === 1 ? 'singular' : 'plural') + unit[0] + 'Text'] || unit[2]));
    });
    if (!parts.length) {
      var hours = Math.floor(seconds / 3600); seconds %= 3600;
      var minutes = Math.floor(seconds / 60); seconds %= 60;
      if (hours) parts.push(hours + ' ' + (labels.hourAbbreviationText || '時間'));
      if (minutes) parts.push(minutes + ' ' + (labels.minuteAbbreviationText || '分'));
      parts.push(seconds + ' ' + (labels.secondAbbreviationText || '秒'));
    }
    return { text: parts.join(' '), expired: false, valid: true };
  }
  function shouldHide(data, expired) {
    return (Number(data.percentPreSold) >= 100 && data.hideAtcButtonWhenFunded === 'yes') ||
      (expired && (data.hideAtcButtonAtEnd === 'yes' ||
        (data.hideAtcButtonAtEnd === 'if_not_funded' && Number(data.percentPreSold) < 100)));
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { countdown: countdown, shouldHide: shouldHide };
  if (!root.document || root.SenilCampaign) return;
  var document = root.document;
  function select(scope, selector) {
    if (!selector) return [];
    try { return Array.from(scope.querySelectorAll(selector)); } catch (_) { return []; }
  }
  // Never apply another product's rules to the main product or recommendation cards.
  function targets(widget, selector) {
    var id = widget.dataset.productId;
    return select(document, selector).filter(function (element) {
      var form = element.closest('form');
      if (form) {
        var input = form.querySelector('input[name="data-product-id"]');
        if (input) return input.value === id;
        if (form.dataset.productId) return form.dataset.productId === id;
        if (form.id === 'product_form_' + id || form.id === 'AddToCartForm-' + id) return true;
      }
      var section = element.closest('.product-section[data-product-id]');
      return section && section.dataset.productId === id;
    });
  }
  var widgets = [];
  var applied = new WeakMap();
  var renamed = new WeakSet();
  var hidden = new Map();
  function restore(element) {
    var previous = hidden.get(element);
    if (!previous) return;
    // Only undo our own display:none, without overwriting another component's state.
    if (element.style.getPropertyValue('display') === 'none') {
      if (previous.value) element.style.setProperty('display', previous.value, previous.priority);
      else element.style.removeProperty('display');
    }
    hidden.delete(element);
  }
  function refresh() {
    widgets = select(document, '[data-senil-campaign]');
    hidden.forEach(function (previous, element) {
      if (!element.isConnected) hidden.delete(element);
      else if (!widgets.some(function (widget) { return !widget.classList.contains('simple') && widget.dataset.productId === previous.productId; })) restore(element);
    });
    update(true);
  }
  function update(force) {
    widgets.forEach(function (widget) {
      var clock = widget.querySelector('.cf-time-left');
      if (!clock) return;
      var data = clock.dataset;
      var result = countdown(data.endTime, Date.now(), data);
      var text = result.valid ? result.text : '締切未設定';
      if (clock.textContent !== text) clock.textContent = text;
      if (widget.classList.contains('simple')) return;
      var shouldBeHidden = result.valid && shouldHide(data, result.expired);
      var state = [shouldBeHidden, data.addToCartButtonSelector, data.replaceAddToCartText,
        data.addToCartTextSelector, data.addToCartReplacementText, data.percentPreSold].join('|');

      if (data.replaceAddToCartText === 'yes' && data.addToCartReplacementText) {
        targets(widget, data.addToCartTextSelector).forEach(function (el) {

          var button = el.closest('button');
          // Respect sold-out, loading and disabled states managed by the theme.
          if (button && (button.disabled || button.getAttribute('aria-busy') === 'true' || button.classList.contains('btn--loading'))) return;
          var defaultText = el.dataset.defaultText;
          if (renamed.has(el) && (!defaultText || el.textContent.trim() !== defaultText.trim())) return;
          if (el.textContent !== data.addToCartReplacementText) el.textContent = data.addToCartReplacementText;
          renamed.add(el);
        });
      }
      if (!force && applied.get(widget) === state) return;
      applied.set(widget, state);
      var controls = targets(widget, data.addToCartButtonSelector);
      // Only migrated/new campaigns control the vendor's support amount modal.
      // Keep legacy campaigns and custom._hidden markup unchanged.
      if (widget.dataset.configSource === 'owned') {
        controls = controls.concat(targets(widget, '[data-senil-support-form] [data-senil-support-control]'));
      }
      controls.forEach(function (el) {
        if (shouldBeHidden) {
          if (!hidden.has(el)) hidden.set(el, {value:el.style.getPropertyValue('display'), priority:el.style.getPropertyPriority('display'), productId:widget.dataset.productId});
          el.style.setProperty('display', 'none');
        } else restore(el);
      });
      var section = widget.closest('.product-section[data-product-id]');
      if (section) select(section, '.success-point').forEach(function (badge) {
        // Preserve the original vendor threshold (strictly greater than 100).
        badge.classList.toggle('active', Number(data.percentPreSold) > 100);
      });
    });
  }
  root.SenilCampaign = { update: refresh };
  function start() {
    refresh();
    root.setInterval(function () { update(false); }, 1000);
    document.addEventListener('shopify:section:load', refresh);
    // Re-scan only when forms/widgets are inserted or removed, not on each clock tick.
    if (root.MutationObserver) {
      var pending = false;
      new root.MutationObserver(function (records) {
        var relevant = records.some(function (record) {
          return Array.from(record.addedNodes).concat(Array.from(record.removedNodes)).some(function (node) {
            return node.nodeType === 1 && (node.matches('form, button, [data-senil-campaign]') || node.querySelector('form, button, [data-senil-campaign]'));
          });
        });
        if (relevant && !pending) {
          pending = true;
          root.setTimeout(function () { pending = false; refresh(); }, 0);
        }
      }).observe(document.documentElement, { childList:true, subtree:true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})(typeof window !== 'undefined' ? window : globalThis);
